import React from 'react';

import {
  ActionContainer,
  ActionLink,
  ActionTitle,
} from '../../shared/styles';
import CompaniesContext, { defaultState } from './context';

export default function Actions() {
  const { dispatch } = React.useContext(CompaniesContext);

  const showEditModal = e => {
    e && e.preventDefault();

    dispatch({ type: 'editCompany', payload: defaultState.currentEditingCompany });
  };

  return (
    <ActionContainer>
      <ActionTitle>Tools</ActionTitle>
      <ActionLink href="#" onClick={showEditModal}>Create Company</ActionLink>
    </ActionContainer>
  );
}
